export default {
  'report.invoice.form.reportType': 'Selecione o Tipo de Relatório',
  'report.invoice.form.reportType.analytical': 'Analítico',
  'report.invoice.form.reportType.synthetic': 'Sintético',
  'report.invoice.form.reportType.byPieces': 'Por Peça',
  'report.invoice.form.reportType.perInvoice': 'Por Nota Fiscal',
  'report.invoice.form.selection.cstpis/cofins': 'CST PIS/COFINS',
};
